export default "__VITE_ASSET__fb828277__"